// extracted by mini-css-extract-plugin
export default {"container":"styles_container__qVK1F","header":"styles_header__6SvhY","title":"styles_title__zJX4I","section":"styles_section__alJTG"};